import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { CurrentSupplierUserInterface } from 'shared/interfaces/current-supplier-user.interface';
import { UserApiService } from 'shared/services';

export enum SsoPropertyKey {
    ICE_PORTAL = 'hasAccessToIce',
    DAL = 'hasAccessToDAL',
}

export const ssoGuard = (ssoPropertyKey: SsoPropertyKey, redirectRouteOnGuardFail: string = 'dashboard'): CanActivateFn => {
    return () => {
        const userApiService = inject(UserApiService);
        const router = inject(Router);
        const destroyRef = inject(DestroyRef);

        return userApiService.getLoginInformation().pipe(
            takeUntilDestroyed(destroyRef),
            map((loginInformation) => {
                if (loginInformation?.isShiji || !(loginInformation as CurrentSupplierUserInterface)[ssoPropertyKey]) {
                    router.navigate([redirectRouteOnGuardFail]);
                    return false;
                }
                return true;
            }),
            catchError(() => {
                router.navigate([redirectRouteOnGuardFail]);
                return of(false);
            }),
        );
    };
};
